<template>
    <el-dialog :title="title + '租户权限'" width="50%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
        <el-row :gutter="20" v-loading="loading">
            <el-col :span="8" class="b_r">
                <el-input size="small" placeholder="请输入关键词" v-model="keyword" maxlength="20" clearable></el-input>
                <div class="tenantBox">
                    <div class="item flex_b_t" v-for="(item, index) in filteredTenantList" :key="index" @click="selTenant(item)">
                        <div class="name omit">{{item.tenantName}}</div>
                        <el-link type="primary" :underline="false" icon="el-icon-check" v-if="temporaryAuthorityId == item.tenantId"></el-link>
                    </div>
                </div>
            </el-col>
            <el-col :span="16">
                <div class="flex_l_t" v-show="treeFlag">
                    <div class="m_r1">开放权限：</div>
                    <div class="treeBox">
                        <el-tree
                                :data="menuList"
                                :props="defaultProps"
                                node-key="id"
                                ref="menuListTree" default-expand-all
                                show-checkbox :class="{ 'tree-disabled': method == 'view' }">
                        </el-tree>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div slot="footer">
            <el-button size="small" @click="visible = false">{{method == 'edit' ? '取消' : '关闭'}}</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick v-if="method == 'edit'" :disabled="loading">提交</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                title: '',
                method: '',
                keyword: '',
                defaultProps: {
                    label: 'name',
                    children: 'children',
                },
                userId: '',
                temporaryAuthorityId: '',
                menuList: [],
                tenantList: [],
                treeFlag: true,
            }
        },
        watch: {
            keyword(val) {
                if(val) {
                    this.treeFlag = false
                } else {
                    this.treeFlag = true
                }
            },
        },
        computed: {
            filteredTenantList() {
                if (!this.keyword) return this.tenantList;
                // 转换为小写进行不区分大小写的筛选
                return this.tenantList.filter(tenant =>
                    tenant.tenantName.includes(this.keyword)
                );
            }
        },
        methods: {
            init(userId, temporaryAuthorityId, method) {
                this.keyword = ''
                this.userId = userId
                this.temporaryAuthorityId = temporaryAuthorityId
                this.method = method
                if (method === 'add') {
                    this.title = `新增`
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.menuListTree.setCheckedKeys([])
                    this.getTenant()
                })
            },
            // 获取详情信息
            getInfo() {
                this.$refs.menuListTree.setCheckedKeys([])
                this.$axios(this.api.user.moreTenantGetById, {tenantId: this.temporaryAuthorityId, userId: this.userId}).then(data => {
                    if (data.status) {
                        let item = this.tenantList.filter(v => v.tenantId == data.data.temporaryAuthorityId)[0]
                        if(!item) {
                            this.loading = false
                            return
                        }
                        this.$set(item, 'menuIds', data.data.menuIds)
                        let ids = item.menuIds.split(',')
                        ids.forEach(value => {
                            this.$refs.menuListTree.setChecked(value, true, false)
                        })
                    } else {
                        this.$message.error('查询失败')
                    }
                    this.loading = false
                })
            },
            // 获取租户
            getTenant() {
                this.loading = true
                this.$axios(this.api.user.getByUserId, {userId: this.userId, flag: 0}).then(res => {
                    if (res.status) {
                        this.tenantList = res.data
                        this.getMenu()
                    } else {
                        this.loading = false
                    }
                })
            },
            // 选择租户
            selTenant(item) {
                this.treeFlag = true
                let menuIds = this.$refs.menuListTree.getCheckedKeys().concat(this.$refs.menuListTree.getHalfCheckedKeys()).join(',')
                let curTenant = this.tenantList.filter(v => v.tenantId == this.temporaryAuthorityId)[0]
                this.$set(curTenant, 'menuIds', menuIds)
                this.$nextTick(() => {
                    this.temporaryAuthorityId = item.tenantId
                    this.getMenu(item)
                })
            },
            // 获取所有菜单
            getMenu(item) {
                this.$axios(this.api.user.findAllTenantMenu, {tenantId: this.temporaryAuthorityId}, 'get').then(data => {
                    if (data.status) {
                        this.menuList = data.data
                        this.$nextTick(() => {
                            if(item) {
                                if(item.menuIds == undefined) {
                                    this.getInfo()
                                } else {
                                    this.$refs.menuListTree.setCheckedKeys([])
                                    let ids = item.menuIds.split(',')
                                    ids.forEach(value => {
                                        this.$refs.menuListTree.setChecked(value, true, false)
                                    })
                                }
                            } else {
                                this.getInfo()
                            }
                        })
                    } else {
                        this.loading = false
                    }
                })
            },
            // 确定
            doSubmit() {
                let menuIds = this.$refs.menuListTree.getCheckedKeys().concat(this.$refs.menuListTree.getHalfCheckedKeys()).join(',')
                if (!menuIds) {
                    this.$message.error('请至少选择一项租户功能权限')
                    return
                }
                let curTenant = this.tenantList.filter(v => v.tenantId == this.temporaryAuthorityId)[0]
                this.$set(curTenant, 'menuIds', menuIds)
                let list = []
                this.tenantList.map(v => {
                    if(v.menuIds != undefined) {
                        list.push({
                            userId: this.userId,
                            temporaryAuthorityId: v.tenantId,
                            menuIds: v.menuIds,
                        })
                    }
                })
                this.loading = true
                this.$axios(this.api.user.moreTenantUpdateById, list, 'post').then(data => {
                    if (data.status) {
                        this.$message.success('操作成功')
                        this.visible = false
                        this.$emit('refreshDataList')
                    } else {
                        this.$message.error(data.msg)
                    }
                    this.loading = false
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .tenantBox {
        height: 72vh;
        overflow-y: auto;
        font-size: 12px;
        padding: 10px 0;

        .item {
            cursor: pointer;
            padding: 5px;
            word-break: break-all;
        }

        .name {
            width: 90%;
        }

        .item:hover {
            background: #f5f5f5;
        }
    }
    .treeBox {
        max-height: 76vh;
        overflow-y: auto;
    }

    ::-webkit-scrollbar {
        display: none;
    }

    .tree-disabled {
        pointer-events: none;
        opacity: 0.6; // 可选：视觉上提示禁用状态
    }
</style>
